import { DragSource } from 'react-dnd';
import { ItemTypes } from 'constants/itemTypes';

const sectionSource = {
  beginDrag({ id, index, position }) {
    return { id, index, position };
  },
  endDrag(props, monitor, component) {
    const initalPosition = monitor.getItem().position;
    // props.position here is not the intial position. it always updates as the
    // item is being dragged
    if (props.position !== initalPosition) {
      props.update({ position: props.position });
    }
  },
};

const collect = (connector, monitor) => ({
  connectDragSource: connector.dragSource(),
  connectDragPreview: connector.dragPreview(),
  isDragging: monitor.isDragging(),
});

export default DragSource(ItemTypes.SECTION, sectionSource, collect);
